import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { UICardContainerComponent } from "../../../../shared/ui-commons/ui-card-page/ui-card-page.components";
import { LocationAssetsPipe } from "@utils/pipes/location-assets.pipe";

@Component({
  selector: 'cv-page-out-schedule',
  templateUrl: './page-out-schedule.component.html',
  imports: [
    UICardContainerComponent,
    LocationAssetsPipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PageOutScheduleComponent {

  actionToAccept(event: Event) {
    event.preventDefault();
  }
}
